import isEmpty from "lodash/isEmpty";
import React, { useEffect, useState } from "react";
import {
    DropdownOnSearchChangeData,
    DropdownProps,
    Grid,
    Select,
    SemanticWIDTHS
} from "semantic-ui-react";

import "./dropdown.scss";

export interface DropDownProps {
  computer?: SemanticWIDTHS;
  tablet?: SemanticWIDTHS;
  mobile?: SemanticWIDTHS;
  placeholder?: string;
  labelName?: string;
  errorMessage?: string;
  customLabelText?: string;
  customGridMain?: string;
  customGridColumn?: string;
  customErrorText?: string;
  defaultValue?: any;
  handleChangeState?: (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => void;
  onSearchChange?: (
    event: React.SyntheticEvent<HTMLElement>,
    data: DropdownOnSearchChangeData
  ) => void;
  currentData?: DropdownOption[];
  disabled?: boolean;
  validate?: boolean;
  required?: boolean;
  search?: boolean | ((options: any[], value: string) => any[]);
  loading?: boolean;
  fluid?: boolean;
  styles?: any;
  customRequired?: any;
  customDropdownStyle?: any;
  removeBoarderView?: boolean;
  onFocus?: () => void;
  upward?: boolean;
  testId?: string;
  onBlur?: () => void;
  showNoResults?: boolean;
  minSearchLength?: number;
  defaultOpen?: boolean;
}

export const DropDown: React.FC<DropDownProps> = ({
  computer = 16,
  tablet = 16,
  mobile = 16,
  placeholder,
  labelName,
  errorMessage,
  customLabelText = "",
  customGridMain = "",
  customGridColumn = "",
  customErrorText = "",
  defaultValue = "",
  handleChangeState,
  onSearchChange,
  currentData,
  disabled = false,
  validate,
  required,
  search = false,
  loading = false,
  fluid = false,
  styles = {},
  customRequired,
  customDropdownStyle = "",
  removeBoarderView = false,
  upward = false,
  onFocus,
  testId,
  onBlur,
  showNoResults,
  minSearchLength,
  defaultOpen
}) => {
  const [value, setValue] = useState<string>(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);
  const removeBorderClass = removeBoarderView ? "removeDropdDownBoarder" : "";

  const getDropdownClassName = ({
    value,
    required,
    validate,
    customRequired,
    customGridColumn,
    removeBoarderView
  }: any) => {
    const isValueEmpty = isEmpty(value);

    if (!customRequired && required && isValueEmpty && validate) {
      return `dropDownMainErrorNotRequired ${customGridColumn} ${removeBorderClass}`;
    }

    if (customRequired && isValueEmpty) {
      return `dropDownMainError ${customGridColumn} ${removeBorderClass}`;
    }

    return `dropDownMain ${customGridColumn} ${removeBorderClass}`;
  };

  return (
    <>
      <label className={`dropDownTextLabel ${customLabelText}`}>{labelName}</label>
      <Grid className={`${customGridMain}`}>
        <Grid.Column
          computer={computer}
          tablet={tablet}
          mobile={mobile}
          className={getDropdownClassName({
            value,
            required,
            validate,
            customRequired,
            customGridColumn,
            removeBoarderView
          })}
        >
          <Select
            className={`selectPadding ${removeBorderClass}`}
            fluid={fluid}
            style={{ padding: "12px", ...styles }}
            placeholder={placeholder}
            options={currentData || []}
            value={value}
            onChange={handleChangeState}
            onSearchChange={onSearchChange}
            disabled={disabled}
            search={search}
            loading={loading}
            selection
            selectOnBlur={false}
            openOnFocus={false}
            {...(defaultOpen !== undefined ? { defaultOpen } : {})}
            {...(showNoResults !== undefined ? { showNoResults } : {})}
            {...(minSearchLength !== undefined ? { minSearchLength } : {})}
            onFocus={onFocus}
            onClose={() => {
              if (onBlur) onBlur();
            }}
            upward={upward}
            data-testid={testId}
          />
          {!customRequired && required && isEmpty(value) && validate ? (
            <span className={`textDropDownErrorNotRequired ${customErrorText}`}>
              {errorMessage}
            </span>
          ) : (
            customRequired &&
            isEmpty(value) && (
              <span className={`textDropDownError ${customErrorText}`}>{errorMessage}</span>
            )
          )}
        </Grid.Column>
      </Grid>
      <br />
    </>
  );
};
